import { Link, useLocation } from "react-router-dom";
import { Brand } from "./brand";
import { useScrolled } from "../../hooks/useScrolled";
import { scrollToSection } from "../../lib/scrollToSection";

const links = [
  { label: "Sobre nosotros", id: "sobre-nosotros" },
  { label: "Packs", id: "packs" },
  { label: "Proceso", id: "proceso" },
  { label: "Reseñas", id: "resenas" },
  { label: "FAQ", id: "faq" },
];

const NavigationLinks = () => (
  <div className="hidden items-center gap-8 lg:flex">
    {links.map((link) => (
      <button key={link.id} data-testid={`nav-${link.id}`} onClick={() => scrollToSection(link.id)}
        className="we-link-underline text-sm text-zinc-300 transition-colors hover:text-white">
        {link.label}
      </button>
    ))}
  </div>
);

export const Nav = () => {
  const scrolled = useScrolled();
  const location = useLocation();
  const onHome = location.pathname === "/";

  return (
    <header
      data-testid="site-nav"
      className={`fixed inset-x-0 top-0 z-[70] transition-colors duration-300 ${
        scrolled ? "border-b border-white/10 bg-black/60 backdrop-blur-xl" : "border-b border-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 md:px-10">
        <Link to="/" data-testid="nav-logo" className="text-xl text-white">
          <Brand />
        </Link>

        {onHome && <NavigationLinks />}

        <button
          data-testid="nav-cta"
          onClick={() => (onHome ? scrollToSection("contacto") : (window.location.href = "/#contacto"))}
          className="ml-3 rounded-full bg-[#00E5FF] px-3 py-2.5 text-xs font-semibold text-[#0A0A0C] transition-transform hover:-translate-y-0.5 sm:px-5 sm:text-sm"
        >
          Solicita tu presupuesto
        </button>
      </nav>
    </header>
  );
};
